import * as Constants from "src/core/Constants/Constants";
import { Button, Popover } from "@mui/material";
import { useTranslation } from "react-i18next";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ReplayRoundedIcon from "@mui/icons-material/ReplayRounded";
import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import React, { useContext } from "react";
import { AppContext } from "src/contexts/AppContext";

export default function GtLegend(): JSX.Element {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { businessUnit } = useContext(AppContext);

  return (
    <>
      <Button
        color="secondary"
        variant="contained"
        endIcon={<HelpOutlineIcon />}
        id="help-button"
        aria-controls={open ? "help-popover" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {t("General.Help")}
      </Button>

      <Popover
        id="help-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <article className="gt-legend">
          <section className="gt-legend__item">
            <CheckBoxIcon className="gt-legend__item-filledIndicator" />
            <span>{t("General.Filled")}</span>
          </section>
          <section className="gt-legend__item">
            <CircleRoundedIcon className="gt-legend__item-notStandardIndicator" />
            <span>{t("General.NotStandard")}</span>
          </section>
          <section className="gt-legend__item">
            <CircleRoundedIcon className="gt-legend__item-defaultIndicator" />
            <span>{t("General.Default")}</span>
          </section>
          <section className="gt-legend__item">
            <ReplayRoundedIcon className="gt-legend__item-revertIndicator" />
            <span>{t("General.Revert")}</span>
          </section>

          {businessUnit === Constants.BusinessUnit.Outsourcing && (
            <section className="gt-legend__item">
              <HelpOutlineIcon />
              <a
                className="gt-legend__item-link"
                href="https://grantthornt.sharepoint.com/sites/GTSE-EngageMod/SitePages/Kom-igang-med-Engagement-Module.aspx"
                target="_blank"
                rel="noreferrer"
              >
                <span className="gt-legend__item-text">
                  {t("General.FAQBCS")}
                </span>
              </a>
            </section>
          )}
          {businessUnit === Constants.BusinessUnit.Audit && (
            <section className="gt-legend__item">
              <HelpOutlineIcon />
              <a
                className="gt-legend__item-link"
                href="https://grantthornt.sharepoint.com/sites/KB-Rev/SitePages/Engagement-Letter-Audit.aspx"
                target="_blank"
                rel="noreferrer"
              >
                <span className="gt-legend__item-text">
                  {t("General.FAQAudit")}
                </span>
              </a>
            </section>
          )}
          {businessUnit === Constants.BusinessUnit.Tax && (
            <section className="gt-legend__item">
              <HelpOutlineIcon />
              <a
                className="gt-legend__item-link"
                href="https://grantthornt.sharepoint.com/sites/KB-Skatt/SitePages/Engagement-Module-f%C3%B6r-Skatt.aspx"
                target="_blank"
                rel="noreferrer"
              >
                <span className="gt-legend__item-text">
                  {t("General.FAQTax")}
                </span>
              </a>
            </section>
          )}
        </article>
      </Popover>
    </>
  );
}
